import type { PivotValueComparison } from '@ztechapps/common.contract'
import { PIVOT_OPERATOR_LABELS } from '../pivot-operator-labels'
import { describePivotOperands } from './describePivotOperands'

/** A Value comparison in the chip voice, e.g. `net (Sum) greater than 1000`. */
export const describePivotValueComparison = ({ measure, operator, values }: PivotValueComparison): string =>
  `${measure.field} (${measure.aggregation}) ${PIVOT_OPERATOR_LABELS[operator].toLowerCase()} ${describePivotOperands(operator, values, false)}`
